'use strict';

angular.module('mean.projects').factory('daysDifferenceService', ['$filter', 'Holidays', 'userService',
    function($filter, Holidays, userService) {
        var holidays = [];
        var dateFormat = 'yyyy-MM-dd';

        /* Get defined holidays in the system */
        var setHolidaysArray = function(username) {
            userService.getMainAccount(username).then(function(account) {
                Holidays.query({'main_account_id': account._id}, function(holiday_db) {
                    if(holiday_db.length === 1) {
                        _.each(holiday_db[0].entries, function(entry) {
                            holidays.push($filter('date')(entry.date, dateFormat));
                        });
                    }
                });
            });
        };

        /* Disables Saturdays, Sundays, and Holidays */
        var disabled = function(date, mode) {
            if(mode === 'day') {
                if(holidays.indexOf($filter('date')(date, dateFormat)) !== -1) {
                    return 1;
                } 
            }
            return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
        };

        var getSkippedDays = function(start_date, end_date) {
            var current_day = moment(start_date);
            var end = getValidDate(end_date);
            var amount = 0;

            while(current_day.day() != end.day()) {
                if(disabled(new Date(current_day), 'day')) {
                    amount = amount + 1;
                }
                
                current_day.add(1, 'day');
            }

            return amount;
        }

        var getDaysFromStart = function(start_date, end_date) {
            var current_day = moment(start_date);
            var end = getValidDate(end_date);
            var amount = 0;

            while(current_day < end) {
                if(!disabled(new Date(current_day), 'day')) {
                    amount += 1;
                }
                
                current_day.add(1, 'day');
            }

            return amount-1;
        }

        var getValidDate = function(date) {
            var current_day = moment(date);

            while(disabled(new Date(current_day), 'day')) {
                current_day.add(1, 'day');
            }

            return current_day;
        }

        /* Gets the number of working days between start and end */
        var getDiffTwoDays = function(start, end) {
            start = getValidDate(start);
            end = getValidDate(end);

            var current_day = start;
            var off_days = 0;

            var days = Number(moment.duration(
                        moment(end).diff(
                            moment(start))).asDays());

            for(var i=0; i<days; i++) {
                if(disabled(new Date(current_day), 'day')) off_days += 1;
                current_day.add(1, 'day');
            }

            days -= off_days;

            return days;
        };

        var getDiffDateAndDays = function(start, days) {
            var end_date = new Date(moment(start).add(days, 'days'));

            return getDiffTwoDays(start, end_date);
        };

        return {
            setHolidaysArray: setHolidaysArray,
            getValidDate: getValidDate,
            getSkippedDays: getSkippedDays,
            getDaysFromStart: getDaysFromStart,
            getDiffTwoDays: getDiffTwoDays,
            getDiffDateAndDays: getDiffDateAndDays,
            disabled: disabled
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/days-difference-service.js